/* eslint new-cap: "off" */

import PropTypes from 'prop-types';
import React from 'react';
import installI18nContext from 'modules/i18n/installI18nContext';
import connectToI18n from 'modules/i18n/connectToI18n';
import PaymentProfileCompletion from './PaymentProfileCompletion.jsx';
import emptyObject from 'modules/utils/emptyObject';
import { updateUserKyc } from 'api/users';
import { INITIAL_LOADING, READY, SAVING } from 'modules/utils/ajaxStatuses';
import { getCountriesAsJSON } from 'models/countries.js';
import { validate, validators } from 'modules/validation';

export class PaymentProfileCompletionContainer extends React.Component {
    static propTypes = {
        backLink: PropTypes.node,
        user: PropTypes.object.isRequired,
        trans: PropTypes.func.isRequired,
        onCompletion: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            clientErrors: emptyObject,
            serverErrors: emptyObject,
            showErrors: false,
            // We need to use this form for the next method fromModelToForm to be defined on the class
            // Via the class properties babel plugin
            formData: this.fromModelToForm(this.props.user),
            countries: [],
            status: INITIAL_LOADING,
        };
    }

    componentDidMount() {
        getCountriesAsJSON().then(this.onCountriesReady);
    }

    onCountriesReady = countries => {
        this.setState({
            countries,
            status: READY,
        });
    };

    fromFormToModel = formData => {
        return {
            phone: formData.phone,
            address: {
                street: formData.street,
                city: formData.cityId,
            },
            birthday: formData.birthday,
            nationality: formData.nationality,
            hasAcceptedTOS: formData.hasAcceptedTOS,
        };
    };

    fromModelToForm = user => {
        // by default, select the country of residence as nationality
        const nationality = user.nationality || user.address.country.code;

        return {
            phone: user.phone || '',
            street: user.address.street || '',
            zipCode: user.address.city.zipCode,
            cityId: user.address.city.id,
            countryId: user.address.country.id,
            birthday: user.birthday || '--',
            nationality,
            hasAcceptedTOS: false,
        };
    };

    validate = formData => {
        const { assertNotBlank, assertValidBirthdate, assertChecked } = validators(
            this.props.trans
        );

        return validate.all([
            validate.prop('hasAcceptedTOS', assertChecked),
            validate.prop('phone', assertNotBlank),
            validate.prop('street', assertNotBlank),
            validate.prop('zipCode', assertNotBlank),
            validate.prop('cityId', assertNotBlank),
            validate.prop('birthday', assertValidBirthdate),
        ])(formData);
    };

    edit = (field, value) => {
        const formData = { ...this.state.formData };
        formData[field] = value;

        const [, clientErrors] = this.validate(formData);

        this.setState({
            clientErrors,
            formData,
        });
    };

    submit = () => {
        const [isValid, clientErrors] = this.validate(this.state.formData);

        if (!isValid) {
            return this.setState({
                clientErrors,
                showErrors: true,
            });
        }

        this.setState({
            status: SAVING,
        });

        const data = this.fromFormToModel(this.state.formData);
        return updateUserKyc(this.props.user.id, data)
            .then(() => {
                this.props.onCompletion();
            })
            .catch(message => {
                if (message?.responseJSON?.detail?.errors) {
                    this.setState({
                        serverErrors: message.responseJSON.detail.errors,
                        showErrors: true,
                        status: READY,
                    });
                }
            });
    };

    render() {
        return (
            <PaymentProfileCompletion
                {...this.state}
                backLink={this.props.backLink}
                edit={this.edit}
                submit={this.submit}
            />
        );
    }
}

export default installI18nContext(connectToI18n(PaymentProfileCompletionContainer));
